import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  color: #fff;
`;

const Title = styled.h1`
  margin-bottom: 2rem;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 150px;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #333;
  background: #1e1e1e;
  color: #fff;
  font-size: 1rem;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.8rem;
  border-radius: 8px;
  border: 1px solid #333;
  background: #1e1e1e;
  color: #fff;
  font-size: 1rem;
`;

const Button = styled.button`
  padding: 0.8rem 2rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #444;
    cursor: not-allowed;
  }
`;

const ResultArea = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background: #252525;
  border-radius: 8px;
  min-height: 100px;
`;

const Pre = styled.pre`
  white-space: pre-wrap;
  word-break: break-all;
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  margin-top: 1rem;
`;

const API_KEY = 'a75e3df9-13d6-4815-ba75-6c9f25415bfa:fx';
const API_URL = 'https://api-free.deepl.com/v2/translate';

const DeepLTestPage = () => {
    const [text, setText] = useState('');
    const [targetLang, setTargetLang] = useState('KO');
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleTranslate = async () => {
        if (!text.trim()) return;

        setLoading(true);
        setError(null);
        setResult(null);

        try {
            const formData = new URLSearchParams();
            formData.append('auth_key', API_KEY);
            formData.append('text', text);
            formData.append('target_lang', targetLang);

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setResult(data);
        } catch (err) {
            console.error('Translation failed:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Title>DeepL API Test</Title>

            <FormGroup>
                <Label>Text to Translate</Label>
                <TextArea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Enter text here..."
                />
            </FormGroup>

            <FormGroup>
                <Label>Target Language</Label>
                <Select
                    value={targetLang}
                    onChange={(e) => setTargetLang(e.target.value)}
                >
                    <option value="KO">Korean</option>
                    <option value="EN-US">English (US)</option>
                    <option value="JA">Japanese</option>
                    <option value="ZH">Chinese</option>
                    <option value="DE">German</option>
                    <option value="FR">French</option>
                    <option value="ES">Spanish</option>
                </Select>
            </FormGroup>

            <Button onClick={handleTranslate} disabled={loading || !text.trim()}>
                {loading ? 'Translating...' : 'Translate'}
            </Button>

            {error && (
                <ErrorMessage>
                    Error: {error}
                </ErrorMessage>
            )}

            {result && (
                <ResultArea>
                    <Label>Result:</Label>
                    <Pre>{JSON.stringify(result, null, 2)}</Pre>
                    {result.translations && result.translations.length > 0 && (
                        <div style={{ marginTop: '1rem' }}>
                            <Label>Translated Text:</Label>
                            <div style={{ fontSize: '1.2rem', marginTop: '0.5rem' }}>
                                {result.translations[0].text}
                            </div>
                        </div>
                    )}
                </ResultArea>
            )}
        </Container>
    );
};

export default DeepLTestPage;
